import React, { Component } from 'react';
import PageFooterForGeneral from './PageFooterForGeneral.js';
import PageFooterForKorean from './PageFooterForKorean.js';
import PageFooterCN from './PageFooterCN.js';
import Market from './Market.js'

function PageFooter(props) {
    let headerTemplateName = Market.CurrentMarket.HeaderFooterTemplate
    if (headerTemplateName == "ko-KR") {
        return (<PageFooterForKorean i18n={props.i18n} />);
    }
    if (headerTemplateName == "zh-CN") {
        return (<PageFooterCN i18n={props.i18n} />);
    }
    return (<PageFooterForGeneral i18n={props.i18n} />);
}

export default PageFooter;